import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import { createRoot } from "react-dom/client";
import reportWebVitals from "./reportWebVitals";

import "react-tooltip/dist/react-tooltip.css";
import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import { createTheme } from "@mantine/core";
import DO from "./DO";
import ErrorBoundary from "./components/ErrorBoundery";

const theme = createTheme({
  /** Put your mantine theme override here */
});

//import { MsalProvider } from "@azure/msal-react";
//import { Configuration, PublicClientApplication } from "@azure/msal-browser";

// MSAL configuration
/*const configuration: Configuration = {
  auth: {
    authority: 'https://login.microsoftonline.com/53e92c36-6617-4e71-a989-dd739ad32a4d',
    clientId: '662cb630-0772-46a1-8978-f1cd052ce4ec'
  }
};*/

//const pca = new PublicClientApplication(configuration);
const container = document.getElementById("root");
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <DO />
    </ErrorBoundary>
  </React.StrictMode>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
